import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import React, { ReactElement } from 'react'
import {
  ReceiptRecoveryAccountingPeriod,
  ReceiptRecoveryStats,
  ReceiptRecoveryTransactionState,
} from 'src/feature/ReceiptRecovery/receiptRecovery.types'
import ReceiptRecoveryOverview from 'src/feature/ReceiptRecovery/ReceiptRecoveryOverview'
import { useTranslate } from 'src/localization/Trns'

import * as style from './ReceiptRecoveryWorkspace.style'

interface ReceiptRecoveryWorkspaceProps {
  accountingPeriods: readonly ReceiptRecoveryAccountingPeriod[]
  isRunActive?: boolean
  onOpenTransactions: (state: ReceiptRecoveryTransactionState) => void
  onPeriodSelect: (periodId: string) => void
  receiptStats: ReceiptRecoveryStats
  runError?: string
  selectedPeriodId: string
}

const ReceiptRecoveryWorkspace = ({
  accountingPeriods,
  isRunActive = false,
  onOpenTransactions,
  onPeriodSelect,
  receiptStats,
  runError,
  selectedPeriodId,
}: ReceiptRecoveryWorkspaceProps): ReactElement => {
  const translate = useTranslate()

  return (
    <main css={style.workspace} data-testid="receipt-recovery-page">
      {isRunActive && (
        <p className="runStatusAnnouncement" role="status" aria-live="polite">
          {translate('Receipt Agent run is in progress.')}
        </p>
      )}
      {runError && (
        <div className="runError">
          <AlertPanel role="alert" variant="severe">
            {runError}
          </AlertPanel>
        </div>
      )}
      <ReceiptRecoveryOverview
        accountingPeriods={accountingPeriods}
        onOpenTransactions={onOpenTransactions}
        onPeriodSelect={onPeriodSelect}
        receiptStats={receiptStats}
        selectedPeriodId={selectedPeriodId}
      />
    </main>
  )
}

export default ReceiptRecoveryWorkspace
